<template>
  <div class="header container">
    <div class="d-flex padding-header justify-content-center mw-100 w-100">
      <div
        class="
          col-12
          px-0
          py-0
          d-flex
          flex-wrap
          header-logo-block
        "
      >
        <div class="col-auto pl-0 align-self-center">
          <img v-if="!companyName" class="header-logo" src="@/assets/WDX_logo.png" alt="logo" />
          <h2 v-else class="text-primary">{{companyName}}</h2>
        </div>
        <div v-if="!isSentEmailUrl()" class="col-auto pl-sm-0 pr-sm-0">
          <nav v-if="!isSingleSignOnUrl()" class="navbar navbar-expand">
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul
                class="
                  d-flex
                  flex-wrap
                  mr-auto
                  w-100
                  my-auto
                  pl-0
                  justify-content-center
                "
              >
                <li class="nav-item active col-auto">
                  <a class="nav-link" href="/">Home</a>
                </li>
                <li class="nav-item col-auto">
                  <a class="nav-link" href="/login.html">Login</a>
                </li>
              </ul>
            </div>
          </nav>
          <div v-else>
            <div class="dropdown mx-auto pt-3 pt-md-0">
              <button
                class="
                  w-100
                  user-select
                  bg-white
                  px-3
                  d-flex
                  justify-content-between
                  pt-1
                "
              >
                <div class="user-select-text my-auto w-100 px-1">
                  {{ getFullNameSingleSignOn() }}
                </div>
                <i class="caret-down my-auto"></i>
              </button>
              <div class="dropdown-content h-100 w-100">
                <div class="navigation-menu-select d-flex flex-wrap mt-2">
                  <a
                    v-on:click="logOff"
                    class="col-12 px-2 pt-1 pb-2 navigation-menu-item text-left"
                  >
                    Log off
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WdxBaseComponentMixin from '../../common/mixins/wdxBaseComponent';
import { mapGetters, mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
export default {
  mixins: [WdxBaseComponentMixin],
  computed: {
    ...mapGetters(['registrationUserFullName'])
  },
  data() {
    return {
      value: null,
      companyName: null
    };
  },
  watch: {
    $route() {
      this.checkCompanyId(this.$route.query.companyId);
    }
  },
  mounted: function () {
    this.checkCompanyId(this.$route.query.companyId);
  },
  methods: {
    switchAccount() {},
    logOff() {
      this.$router.push({ name: 'emailInput' });
    },
    getFullNameSingleSignOn() {
      return this.registrationUserFullName;
    },
    isSingleSignOnUrl() {
      if (this.$route.path === '/signin' || this.$route.path === '/') {
        return false;
      } else {
        return true;
      }
    },
    isSentEmailUrl(){
      if(this.$route.path === '/email-sent') return true;
      return false;
    },
    checkCompanyId(companyId) {
      if (!companyId) {
        this.companyName = null;
        return;
      }

      this.$userService
        .checkCompanyInformation(companyId)
        .then((response) => {
          this.companyName = response.data;
        })
        .catch(() => {
          this.companyName = null;
        })
    },
  }
};
</script>

<style>
.dropdown {
  max-width: 200px;
  width: 200px;
}
.user-select-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.navigation-menu-select {
  padding: 8px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
}

.navigation-menu-item {
  font-family: Arial !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  text-align: center;
  color: #212529;
}

.dropdown-content {
  display: none;
  position: absolute;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.user-select {
  min-height: 50px;
  border: 1px solid #d8d8d8;
  border-radius: 5px;
}

.caret-down::before {
  position: relative;
  right: 0;
  top: 65%;
  color: #999;
  margin-top: 4px;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 0px 0px 0;
  content: url("data:image/svg+xml,%3Csvg width='22' height='12' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L7 7L13 1' stroke='%23979797'/%3E%3C/svg%3E");
}
</style>
